import { BlotterColumn } from 'widgets/blotter/columns/ColumnPortfolio';
import { GridFiltersState } from 'widgets/store/grid/filters/FilterState';
import { ConfigStateWithGridSupport } from 'widgets/store/grid/reducer';

export interface BlotterConfiguration
    extends ConfigStateWithGridSupport<BlotterColumn>,
        GridFiltersState<BlotterColumn> {}

export const initialBlotterConfiguration: BlotterConfiguration = {
    visibleColumns: ['symbol', 'side', 'qty', 'fillQty', 'state', 'avgPxC'],
    sort: [],
    filters: [],
    columnWidths: {},
};
